var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdown-pdf-container" }, [
    _c(
      "div",
      {
        staticClass: "question-title-pdf",
        staticStyle: {
          "font-weight": "bold",
          "font-size": "14px",
          "padding-bottom": "8px",
        },
      },
      [_vm._v(" Câu " + _vm._s(_vm.question.index + 1) + ": ")]
    ),
    _vm.dropdownQuestions.length > 0
      ? _c("div", { staticClass: "mb-2 mt-2" }, [
          _c(
            "div",
            {
              staticClass: "font-weight-medium mb-1",
              staticStyle: { "font-size": "14px", "font-weight": "bold" },
            },
            [_vm._v("Danh sách câu hỏi:")]
          ),
          _c(
            "div",
            { staticStyle: { "padding-left": "8px" } },
            _vm._l(_vm.dropdownQuestions, function (qItem, idx) {
              return _c(
                "div",
                {
                  key: qItem.id || idx,
                  staticStyle: { "margin-bottom": "6px", display: "block" },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "margin-right": "8px",
                        "vertical-align": "top",
                      },
                    },
                    [_vm._v(_vm._s(qItem.index + 1) + ".")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "vertical-align": "top",
                        width: "calc(100% - 40px)",
                      },
                    },
                    [
                      _c("div", {
                        staticStyle: { display: "inline-block" },
                        domProps: {
                          innerHTML: _vm._s(_vm.formatInlineHtml(qItem.html)),
                        },
                      }),
                      !_vm.isQuestionPaper && !_vm.submission.isStudentWork
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "ml-2 d-inline-flex align-center",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color: _vm.getChildResult(qItem.id)
                                        .isCorrect
                                        ? "#4bca81"
                                        : "#d4504c",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " [" +
                                        _vm._s(
                                          _vm.getChildResult(qItem.id)
                                            .studentLabel
                                        ) +
                                        "] "
                                    ),
                                    _c("span", {
                                      staticStyle: { "margin-left": "2px" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getChildResult(qItem.id).isCorrect
                                            ? "&#10003;"
                                            : "&#10005;"
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.submission.isStudentWork
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "ml-2",
                                staticStyle: {
                                  "font-weight": "bold",
                                  color: "#000",
                                },
                              },
                              [
                                _vm._v(
                                  " [" +
                                    _vm._s(
                                      _vm.getChildResult(qItem.id).studentLabel
                                    ) +
                                    "] "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm.optionsPool.length > 0
      ? _c(
          "div",
          { staticClass: "mb-2 mt-2" },
          [
            _c(
              "div",
              {
                staticClass: "font-weight-medium mb-1",
                staticStyle: { "font-size": "14px", "font-weight": "bold" },
              },
              [_vm._v("Danh sách lựa chọn:")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "block",
                  width: "100%",
                  "padding-left": "8px",
                },
              },
              _vm._l(_vm.optionsPool, function (opt) {
                return _c(
                  "div",
                  {
                    key: opt.key,
                    staticStyle: {
                      display: "inline-block",
                      "margin-right": "25px",
                      "margin-bottom": "5px",
                      "vertical-align": "top",
                    },
                  },
                  [
                    _c("span", { staticStyle: { "margin-right": "4px" } }, [
                      _vm._v(_vm._s(opt.label) + "."),
                    ]),
                    _c("div", {
                      staticStyle: { display: "inline-block" },
                      domProps: {
                        innerHTML: _vm._s(_vm.formatInlineHtml(opt.value)),
                      },
                    }),
                  ]
                )
              }),
              0
            ),
            !_vm.isQuestionPaper
              ? _c("v-divider", {
                  staticClass: "my-2",
                  staticStyle: { opacity: "0.3" },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }